"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoadNetwork$ = exports.RoadNetwork$outboundSchema = exports.RoadNetwork$inboundSchema = void 0;
exports.roadNetworkToJSON = roadNetworkToJSON;
exports.roadNetworkFromJSON = roadNetworkFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const closestmotorwayjunction_js_1 = require("./closestmotorwayjunction.js");
/** @internal */
exports.RoadNetwork$inboundSchema = z.object({
    closest_motorway_junction: z.nullable(closestmotorwayjunction_js_1.ClosestMotorwayJunction$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "closest_motorway_junction": "closestMotorwayJunction",
    });
});
/** @internal */
exports.RoadNetwork$outboundSchema = z.object({
    closestMotorwayJunction: z.nullable(closestmotorwayjunction_js_1.ClosestMotorwayJunction$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        closestMotorwayJunction: "closest_motorway_junction",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var RoadNetwork$;
(function (RoadNetwork$) {
    /** @deprecated use `RoadNetwork$inboundSchema` instead. */
    RoadNetwork$.inboundSchema = exports.RoadNetwork$inboundSchema;
    /** @deprecated use `RoadNetwork$outboundSchema` instead. */
    RoadNetwork$.outboundSchema = exports.RoadNetwork$outboundSchema;
})(RoadNetwork$ || (exports.RoadNetwork$ = RoadNetwork$ = {}));
function roadNetworkToJSON(roadNetwork) {
    return JSON.stringify(exports.RoadNetwork$outboundSchema.parse(roadNetwork));
}
function roadNetworkFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.RoadNetwork$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'RoadNetwork' from JSON`);
}
//# sourceMappingURL=roadnetwork.js.map